import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const House: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 25, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 25) / 25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6395 24.2267H4.36047C1.95349 24.2267 0 22.2732 0 19.8663V10.0523C0 8.63371 0.697674 7.2965 1.86046 6.48255L10 0.784883C11.5 -0.261628 13.5116 -0.261628 15 0.784883L23.1395 6.48255C24.3023 7.2965 25 8.63371 25 10.0523V19.8663C25 22.2732 23.0465 24.2267 20.6395 24.2267ZM12.5 1.73837C11.9767 1.73837 11.4535 1.90116 11 2.21511L2.86047 7.91278C2.16279 8.40115 1.74419 9.20348 1.74419 10.0523V19.8663C1.74419 21.3081 2.9186 22.4825 4.36047 22.4825H20.6395C22.0814 22.4825 23.2558 21.3081 23.2558 19.8663V10.0523C23.2558 9.20348 22.8372 8.40115 22.1395 7.91278L14 2.21511C13.5465 1.90116 13.0233 1.75 12.5 1.75V1.73837Z"
        fill="currentColor"
      />
      <path
        d="M17.1515 24.2269H7.84914C7.3724 24.2269 6.97705 23.8315 6.97705 23.3548V17.5408C6.97705 14.4943 9.4538 12.0176 12.5003 12.0176C15.5468 12.0176 18.0236 14.4943 18.0236 17.5408V23.3548C18.0236 23.8315 17.6282 24.2269 17.1515 24.2269ZM8.72124 22.4827H16.2794V17.5408C16.2794 15.4594 14.5817 13.7618 12.5003 13.7618C10.4189 13.7618 8.72124 15.4594 8.72124 17.5408V22.4827Z"
        fill="currentColor"
      />
    </svg>
  )
})

House.displayName = 'House'
